import React, { useEffect, useRef, memo, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const TradingViewETFHeatmap = memo(({ height = '500px' }) => {
  const container = useRef();
  const [hasLoaded, setHasLoaded] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  useEffect(() => {
    if (inView && !hasLoaded && container.current) {
      setHasLoaded(true);
      
      const script = document.createElement('script');
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-etf-heatmap.js';
      script.type = 'text/javascript';
      script.async = true;
      script.innerHTML = `
        {
          "width": "100%",
          "height": "100%",
          "dataSource": "AllUSEtf",
          "blockSize": "Value.Traded",
          "blockColor": "change",
          "locale": "en",
          "symbolUrl": "",
          "colorTheme": "light",
          "hasTopBar": true,
          "isDataSetEnabled": true,
          "isZoomEnabled": true,
          "hasSymbolTooltip": true
        }`;
      
      container.current.appendChild(script);
    }
  }, [inView, hasLoaded]);

  return (
    <div ref={ref} className="tradingview-widget-container" style={{ height, width: '100%' }}>
      <div ref={container} style={{ height: '100%', width: '100%' }}>
        {!hasLoaded && <div className="text-center py-8 text-gray-500">Loading ETF heatmap...</div>}
      </div>
    </div>
  );
});

TradingViewETFHeatmap.displayName = 'TradingViewETFHeatmap';

export default TradingViewETFHeatmap;
